import { render, staticRenderFns } from "./CartResume.vue?vue&type=template&id=01d1bbd8&scoped=true"
import script from "./CartResume.vue?vue&type=script&lang=ts"
export * from "./CartResume.vue?vue&type=script&lang=ts"
import style0 from "./CartResume.vue?vue&type=style&index=0&id=01d1bbd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1bbd8",
  null
  
)

export default component.exports